import { Clock, Cog, TrendingUp } from "lucide-react";

const cards = [
  {
    icon: Clock,
    title: "Save Time",
    desc: "Reduce repetitive work and administrative tasks with AI workflows you can actually use this week.",
  },
  {
    icon: Cog,
    title: "Automate Operations",
    desc: "Build systems that run with less manual effort. Stop doing what software should be doing for you.",
  },
  {
    icon: TrendingUp,
    title: "Grow Smarter",
    desc: "Use AI tools that create leverage instead of complexity. Practical setups for lean teams.",
  },
];

export const WhatWeDo = () => {
  return (
    <section
      id="what-we-do"
      data-testid="what-we-do-section"
      className="relative py-24 sm:py-32 bg-[#FAFAFA] border-y border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="max-w-3xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#0052FF] mb-5">
            What OperatorAI Does
          </div>
          <h2
            data-testid="what-we-do-headline"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1] text-[#0A0A0A]"
          >
            Practical AI. Real workflows. Real results.
          </h2>
          <p className="mt-5 text-lg text-[#525252] max-w-2xl">
            No hype. No 100-tool stacks. Just workflows that operators and
            small business teams can deploy and actually keep running.
          </p>
        </div>

        <div
          data-testid="features-grid"
          className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {cards.map(({ icon: Icon, title, desc }, idx) => (
            <article
              key={title}
              data-testid={`feature-card-${idx}`}
              className="group relative bg-white border border-[#E5E5E5] rounded-2xl p-8 sm:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-[#0A0A0A]/20"
            >
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#0052FF]/8 text-[#0052FF] mb-6 transition-colors group-hover:bg-[#0052FF] group-hover:text-white">
                <Icon size={22} strokeWidth={2.2} />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-[#0A0A0A]">
                {title}
              </h3>
              <p className="mt-3 text-base text-[#525252] leading-relaxed">
                {desc}
              </p>
              <div className="absolute top-6 right-6 text-xs font-mono text-[#9CA3AF]">
                0{idx + 1}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
